module.exports = __webpack_public_path__ + "e1f89cbe0e82011f8a2a7ac56bf9f8c6.fbx";